import { Pipe, PipeTransform } from '@angular/core';
import { stripCaptureMarker } from './capture-marker';

/**
 * Pure pipe wrapper around `stripCaptureMarker`. Unlike `parseMessageContent` (see the
 * change-detection trap documented in `parse-message-content.pipe.ts`), this returns a
 * plain string, so a stable input yields an identical output value every cycle.
 */
@Pipe({
  name: 'stripCaptureMarker',
})
export class StripCaptureMarkerPipe implements PipeTransform {
  transform(content: string | null | undefined): string {
    return stripCaptureMarker(content ?? '');
  }
}
